import theme from '../../utils/theme'
import PropTypes from 'prop-types'
import classes from './style.module.css'

export const Paper = ({
	children,
	margin = 0,
	padding = 10,
	overflow = '',
	textAlign = '',
	borderRadius = 10,
	backgroundColor = '',
}) => {

	const style = {
		margin,
		padding,
		overflow,
		textAlign,
		borderRadius,
		backgroundColor: theme[backgroundColor] || backgroundColor,
	}

	return (
		<div className={classes.paper} style={style} data-overflow={overflow}>
			{children}
		</div>
	)
}

Paper.propTypes = {
	children: PropTypes.any,
	margin: PropTypes.any,
	padding: PropTypes.number,
	overflow: PropTypes.string,
	textAlign: PropTypes.string,
	borderRadius: PropTypes.string,
	backgroundColor: PropTypes.string.isRequired,
}